import { HttpClient, HttpBackend } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BrokerRegistrationConfirmationResult } from "src/app/models/broker-registration/broker-registration-confirmation-type.model";
import { BrokerRegistrationModel } from "src/app/models/broker-registration/broker-registration.model";
import { RegisterIndividualBrokerResult } from "src/app/models/broker-registration/register-broker-result.model";
import { Configuration } from "src/assets/Configuration";

@Injectable({
  providedIn: 'root'
})
export class BrokerRegistrationService {

  private httpClient: HttpClient;

  constructor(httpBackend: HttpBackend) {
    this.httpClient = new HttpClient(httpBackend);
  }

  public register(
    model: BrokerRegistrationModel
  ): Observable<RegisterIndividualBrokerResult> {
    return this.httpClient.post<RegisterIndividualBrokerResult>(
      Configuration.getApiBaseUrl() + '/broker-registration', 
      model,
    );
  }

  public confirm(
    token: string
  ): Observable<BrokerRegistrationConfirmationResult> {
    return this.httpClient.post<BrokerRegistrationConfirmationResult>(
      Configuration.getApiBaseUrl() + '/broker-registration/confirm',
      { token }
    );
  }
}
